/* istanbul ignore next - this is a noop function */
export const noop = () => {};
